// extracted by mini-css-extract-plugin
export default {"back":"Back_back__IIXMx","icon":"Back_icon__3Y4YF"};